export enum ConsentType {
  Ekyc = 1,
  Kyc = 2,
}
